<ng-container *ngIf="!isLoading">    
    <button id="{{widgetContent?.id}}" (click)="onClick()"
        class="widget-tile">
        <div class="widget-icon-box">
            <img src={{widgetContent.icon}} alt="{{ widgetContent.label }} icon"/>
        </div>
        <div class="widget-label">{{ widgetContent.label | translate }}</div>
    </button>

    <ng-container *ngIf="isOpenModal">
        <app-upload-type-modal *ngIf="widgetContent.id === 'addDocsId'"
            [onModalLoad]="true"
            (closeModal)="closeModal($event)"
        ></app-upload-type-modal>

        <app-billing-question *ngIf="widgetContent.id === 'askQuestionId'"
            [onModalLoad]="true"
            (closeModal)="closeModal($event)"
        ></app-billing-question>
    </ng-container>
</ng-container>
